import '@scripts/global';
import common from '@route/common';
import loading from '@component/loading';

const init = () => {
    window.requestAnimationFrame(function ready() {
        if ( !document.body ) {
            return window.requestAnimationFrame( ready );
        }

        loading();

        return common();
    });
};

init();
